module.exports = __webpack_public_path__ + "images/help-videos-preview-newtodo-5c883fe0bb1a258e9a03de19a3f7ee77.png";